import { AiService } from './AiService';

export const AiNewsService = {
    generateCupsetHeadline: async (winnerName: string, loserName: string, winnerLeague: string, loserLeague: string, useAi: boolean): Promise<string> => {
        if (useAi) {
            try {
                return await AiService.generateCupsetHeadline(winnerName, loserName, winnerLeague, loserLeague);
            } catch (e) {
                console.error("Error generating cupset headline, using fallback:", e);
                return "GIANT KILLING!"; // Fallback on API error
            }
        } else {
            const templates = [
                `${winnerName.split(' ').pop()} SHOCK ${loserName.split(' ').pop()}`,
                "CUPSET! GIANTS CRASH OUT",
                `${winnerName.toUpperCase()} PULL OFF FAMOUS WIN`,
                "MAGIC OF THE CUP IS ALIVE AND WELL"
            ];
            return templates[Math.floor(Math.random() * templates.length)];
        }
    }
};